import React, { useEffect, useState } from 'react';
import get from 'lodash/get';
import toLower from 'lodash/toLower';
import { useTranslation } from 'react-i18next';
import { ExclamationCircleFilled, PaperClipOutlined } from '@ant-design/icons';
import { Card, Button, Divider, Timeline, Modal, message } from 'antd';
import {
  checkActiveOpportunityCasesExist,
  getReconciliationOpportunityDetailsStage,
  closeActiveOpportunityCases,
  updateOpportunityLandlordBookingStatus,
} from '~actions/reconciliation';
import moment from 'moment';
import formatPrice from '~helpers/currency';
import { BookingStatus } from '~constants/reconciliationStatus';
import CommentModal from '~pages/reconciliation/detail/comment-modal';
import ImageGallery from '~pages/reconciliation/detail/image-gallery';
import { BookingDetailsSuccess as BookingDetailsSuccessIcon } from '~components/svgs';
import { getMainStatus, getSecondaryStatus } from './utils';
/* eslint-disable */
export default function index({ opportunityDetails, opportunityId }) {
  const { t } = useTranslation();
  const [details, setDetailsData] = useState(null);
  const [modalShow, setModalShow] = useState(false);
  const [checkModalShow, setCheckModalShow] = useState(false);
  const [galleryShow, setGalleryShow] = useState(false);
  const [stageComment, setStageComment] = useState(null);
  const [showCommentSucc, setShowCommentSucc] = useState(false);
  const MainStatus = getMainStatus(t);

  useEffect(() => {
    getReconciliationOpportunityDetailsStage({ id: opportunityId }, data => {
      if (
        get(data, 'opportunityStateChanges.0.preLandlordBookingStatus') !==
        BookingStatus.PENDING_APPROVAL
      ) {
        //todo: modify to ===
        if (get(data, 'opportunityStateChanges.0.opportunityPendingNote')) {
          setStageComment(get(data, 'opportunityStateChanges.0.opportunityPendingNote'));
        }
      }

      setDetailsData(data);
    });
  }, [opportunityId]);

  const handleCommonClick = () => {
    setModalShow(true);
  };

  const handleApprove = () => {
    checkActiveOpportunityCasesExist(
      {
        opportunityId,
      },
      res => {
        if (res && res.exist) {
          setCheckModalShow(true);
        } else if (res && !res.exist) {
          executeApproveProcess();
        }
      },
    );
  };

  const executeApproveProcess = () => {
    updateOpportunityLandlordBookingStatus(
      {
        id: opportunityId,
        data: {
          landlordBookingStatus: BookingStatus.APPROVED,
        },
      },
      () => {
        setDetailsData({
          ...details,
          landlordBookingStatus: BookingStatus.APPROVED,
          opportunityStateChanges: [
            {
              currentLandlordBookingStatus: BookingStatus.APPROVED,
              currentSecondaryLandlordBookingStatus: null,
              opportunityPendingNote: null,
              updatedAt: moment(),
            },
            ...details.opportunityStateChanges,
          ],
        });

        setStageComment(null);
        message.success(t('landlord.booking.reconciliation.details.stage.approve.succ'));
      },
    );
  };

  const handleModalCancel = () => {
    setModalShow(false);
  };

  const handleCancelGotIt = () => {
    setShowCommentSucc(false);
  };

  const handleCancelApproveCheckModal = () => {
    setCheckModalShow(false);
  };

  const handleApproveCheckModal = () => {
    setCheckModalShow(false);
    closeActiveOpportunityCases({ opportunityId }, () => {
      executeApproveProcess();
    });
  };

  const handleCommonSuccess = (comment, status) => {
    setStageComment(comment);
    setDetailsData(status);
    setModalShow(false);
    setShowCommentSucc(true);
  };

  const handleOpenCommentImageGallery = () => {
    setGalleryShow(true);
  };

  const handleCloseCommentImageGallery = () => {
    setGalleryShow(false);
  };

  const handleTimeLineColor = (_m, _index) => {
    return _index == 0
      ? _m.currentLandlordBookingStatus === BookingStatus.PENDING_APPROVAL
        ? 'timeline-red'
        : 'timeline-green'
      : '';
  };

  return !details ? null : (
    <div className="reconciliation-details-box">
      <div className="reconciliation-details-box__patcher">
        <Card title="Reconciliation details" bordered={false}>
          <div className="reconciliation-details-box__header">
            <div>{t('landlord.booking.reconciliation.details.stage.commission_total')}</div>
            <div className="reconciliation-price">
              {formatPrice(
                get(details, 'completedXbooking.commission.totalCommissionValue') || 0,
                get(details, 'completedXbooking.commission.currency'),
              )}
            </div>
          </div>
          <ul className="reconciliation-details-box__commission">
            <li>
              <div>{t('landlord.booking.reconciliation.details.stage.normal_ommission_value')}</div>
              <div>
                {formatPrice(
                  get(details, 'completedXbooking.commission.value') || 0,
                  get(details, 'completedXbooking.commission.currency'),
                )}
              </div>
            </li>
            <li>
              <div>{t('landlord.booking.reconciliation.details.stage.bonus_commission_value')}</div>
              <div>
                {formatPrice(
                  get(details, 'completedXbooking.commission.bonusValue') || 0,
                  get(details, 'completedXbooking.commission.currency'),
                )}
              </div>
            </li>
          </ul>
          <div className="reconciliation-details-box__invoice_number">
            <div>{t('landlord.booking.reconciliation.details.stage.invoice_number')}:</div>
            <div className="invoice_number_value">
              {get(details, 'completedXbooking.commission.invoiceNumber') || '-'}
            </div>
          </div>
          <Divider />
          <div className="reconciliation-details-box__header">
            <div className="fix-line-height">
              {t('landlord.booking.reconciliation.details.stage.reconciliation_stage')}
            </div>
          </div>

          {stageComment && (
            <div className="reconciliation-details-box__stage">
              <label className="reconciliation-details-box__stage-title">
                {t(
                  `landlord.booking.reconciliation.details.modal.reason_option.${toLower(
                    stageComment.pendingNote,
                  )}`,
                )}
              </label>
              <p className="reconciliation-details-box__stage-summary">
                {stageComment.description}
              </p>
              <If condition={stageComment.opportunityPendingNoteFiles.length > 0}>
                <p
                  className="reconciliation-details-box__stage-file"
                  onClick={handleOpenCommentImageGallery}
                >
                  <PaperClipOutlined className="reconciliation-details-box__stage-file-icon" />
                  {`${stageComment.opportunityPendingNoteFiles.length} Files`}
                </p>
              </If>
            </div>
          )}

          <Timeline>
            {details.opportunityStateChanges.map((m, index) => (
              <Timeline.Item
                key={index}
                dot={<div className={`timeline-dot ${handleTimeLineColor(m, index)}`}></div>}
              >
                <div
                  className={
                    index == 0
                      ? m.currentLandlordBookingStatus === BookingStatus.PENDING_APPROVAL
                        ? 'last-stage timeline-txt-red '
                        : 'last-stage timeline-txt-green '
                      : 'normal-stage'
                  }
                >
                  {MainStatus.getValueByKey(m.currentLandlordBookingStatus)}
                  {m.currentSecondaryLandlordBookingStatus
                    ? ' - ' + getSecondaryStatus(m.currentSecondaryLandlordBookingStatus, t)
                    : ''}
                </div>
                <div className="status-time">{moment(m.updatedAt).format('DD/MM/YYYY')}</div>
              </Timeline.Item>
            ))}
          </Timeline>
        </Card>
      </div>
      <div className="reconciliation-details-box__footer">
        {details.landlordBookingStatus !== BookingStatus.PENDING_APPROVAL && (
          <Button className="comment" onClick={handleCommonClick}>
            {t('landlord.booking.reconciliation.details.stage.comment')}
          </Button>
        )}

        <Button
          type="primary"
          onClick={handleApprove}
          disabled={
            [
              BookingStatus.APPROVED,
              BookingStatus.READY_TO_INVOICE,
              BookingStatus.INVOICED,
              BookingStatus.PAID,
            ].indexOf(details.landlordBookingStatus) > -1
          }
        >
          {t('landlord.booking.reconciliation.details.stage.approve')}
        </Button>
      </div>
      {modalShow && (
        <CommentModal
          onCancel={handleModalCancel}
          details={details}
          onSuccess={handleCommonSuccess}
          opportunityId={opportunityId}
        />
      )}
      {checkModalShow && (
        <Modal
          className="reconciliation-details-box__check-modal"
          visible={true}
          closable={false}
          footer={null}
        >
          <div className="reconciliation-details-box__check-modal-content">
            <ExclamationCircleFilled className="reconciliation-details-box__check-modal-icon" />
            <h3 className="reconciliation-details-box__check-modal-title">
              {t('landlord.booking.reconciliation.details.stage.modal.approve_it.title')}
            </h3>
            <p className="reconciliation-details-box__check-modal-summary">
              {t('landlord.booking.reconciliation.details.stage.modal.approve_it.summary')}
            </p>
            <div className="reconciliation-details-box__check-modal-btn-container">
              <Button key="no" onClick={handleCancelApproveCheckModal}>
                No
              </Button>
              <Button key="yes" type="primary" onClick={handleApproveCheckModal}>
                Yes
              </Button>
            </div>
          </div>
        </Modal>
      )}
      {showCommentSucc && (
        <Modal
          className="reconciliation-details-box__succ-modal"
          title={t('landlord.booking.reconciliation.details.stage.modal.title')}
          visible={true}
          onCancel={handleCancelGotIt}
          footer={[
            <Button key="ok" type="primary" onClick={handleCancelGotIt}>
              {t('landlord.booking.reconciliation.details.stage.modal.gotit')}
            </Button>,
          ]}
        >
          <BookingDetailsSuccessIcon className="booking-details-success" />
          {t('landlord.booking.reconciliation.details.stage.modal.right.txt')}
        </Modal>
      )}
      {galleryShow && (
        <ImageGallery
          onClose={handleCloseCommentImageGallery}
          files={stageComment.opportunityPendingNoteFiles}
        />
      )}
    </div>
  );
}
